// document.addEventListener('DOMContentLoaded', function () {
//   const FREE_ITEM_ID = '51304554234176'; 
//   const REQUIRED_QUANTITY = 2;           

//   let processingTimeout = null;
//   let isCurrentlyProcessing = false;

//   function normalizeId(val) {
//     return val === undefined || val === null ? '' : String(val);
//   }

//   function isFreeItemMatch(item) {
//     const id = normalizeId(item.id || item.variant_id || item.variantId);
//     const productId = normalizeId(item.product_id || item.productId);
//     const props = item.properties || {};
//     const propFlag = props._free_gift || props._free_gift === '' ? props._free_gift : undefined;

//     if (id === FREE_ITEM_ID) return true;
//     if (productId === FREE_ITEM_ID) return true;
//     if (propFlag !== undefined && String(propFlag) === 'true') return true;

//     return false;
//   }

//   async function fetchCartJson() {
//     const res = await fetch('/cart.js', { cache: 'no-store' });
//     if (!res.ok) throw new Error('Failed to fetch /cart.js: ' + res.status);
//     return res.json();
//   }

//   const productTagCache = {};

//   async function getProductTags(handle) {
//     if (!handle) return [];

//     if (productTagCache[handle]) {
//       return productTagCache[handle];
//     }

//     try {
//       const res = await fetch(`/products/${handle}.js`);
//       const data = await res.json();
//       const tags = data.tags || [];
//       productTagCache[handle] = tags;
//       return tags;
//     } catch (e) {
//       console.warn("Failed fetching product tags for", handle, e);
//       return [];
//     }
//   }

//   async function manageFreeItem() {
//     if (isCurrentlyProcessing) {
//       console.log('[freebie] Already processing — skipping');
//       return;
//     }
//     isCurrentlyProcessing = true;
//     console.log('[freebie] === start check ===');

//     try {
//       const cart = await fetchCartJson();

//       // Separate free vs non-free items
//       let totalNonFreeQuantity = 0;
//       let freeItemKey = null;
//       let freeItemQuantity = 0;

//       for (const item of cart.items || []) {
//         if (isFreeItemMatch(item)) {
//           freeItemKey = item.key || item.id || item.variant_id || item.variantId;
//           freeItemQuantity = item.quantity;
//         } else {
//           const handle = item.handle || "";
//           const tags = await getProductTags(handle);

//           if (tags.includes("collars")) {
//             console.log("[freebie] Skipping item because it has tag 'collars'");
//             continue;
//           }

//           totalNonFreeQuantity += (item.quantity || 0);
//         }
//       }

//       const shouldHaveFreeItem = totalNonFreeQuantity >= REQUIRED_QUANTITY;
//       const hasFreeItem = !!freeItemKey;

//       console.log('[freebie] non-free qty:', totalNonFreeQuantity, 'shouldHaveFreeItem:', shouldHaveFreeItem, 'hasFreeItem:', hasFreeItem, 'freeQty:', freeItemQuantity, 'freeKey:', freeItemKey);

//       if (shouldHaveFreeItem && !hasFreeItem) {
//         console.log('[freebie] Action: Add freebie (qty 1)');
//         const addResp = await fetch('/cart/add.js', {
//           method: 'POST',
//           headers: { 'Content-Type': 'application/json' },
//           body: JSON.stringify({
//             id: FREE_ITEM_ID,
//             quantity: 1,
//             properties: { '_free_gift': 'true' }
//           })
//         });

//         if (!addResp.ok) {
//           console.warn('[freebie] Add failed:', addResp.status);
//         } else {
//           console.log('[freebie] Freebie added');
//           publish(PUB_SUB_EVENTS.cartUpdate, { source: 'free-item-handler' });
//         }
//       }

//       else if (!shouldHaveFreeItem && hasFreeItem) {
//         console.log('[freebie] Action: Remove freebie (qty 0)');
//         const remResp = await fetch('/cart/change.js', {
//           method: 'POST',
//           headers: { 'Content-Type': 'application/json' },
//           body: JSON.stringify({
//             id: freeItemKey,
//             quantity: 0
//           })
//         });

//         if (!remResp.ok) {
//           console.warn('[freebie] Remove failed:', remResp.status);
//         } else {
//           console.log('[freebie] Freebie removed');
//           publish(PUB_SUB_EVENTS.cartUpdate, { source: 'free-item-handler' });
//         }
//       } else if (shouldHaveFreeItem && hasFreeItem && freeItemQuantity !== 1) {
//         console.log('[freebie] Action: Fix freebie quantity to 1 (was', freeItemQuantity + ')');
//         const fixResp = await fetch('/cart/change.js', {
//           method: 'POST',
//           headers: { 'Content-Type': 'application/json' },
//           body: JSON.stringify({
//             id: freeItemKey,
//             quantity: 1
//           })
//         });

//         if (!fixResp.ok) {
//           console.warn('[freebie] Fix qty failed:', fixResp.status);
//         } else {
//           console.log('[freebie] Freebie qty corrected to 1');
//           publish(PUB_SUB_EVENTS.cartUpdate, { source: 'free-item-handler' });
//         }
//       }
//       else {
//         console.log('[freebie] ✓ state correct — no action needed');
//       }
//     } catch (err) {
//       console.error('[freebie] Error managing free item:', err);
//     } finally {
//       setTimeout(() => {
//         isCurrentlyProcessing = false;
//       }, 1200);

//       console.log('[freebie] === check complete ===');
//     }
//   }

//   subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
//     try {
//       console.log('[freebie] Cart update event, source:', event && event.source);

//       if (event && event.source === 'free-item-handler') {
//         console.log('[freebie] Ignoring self-triggered update');
//         return;
//       }

//       if (processingTimeout) {
//         clearTimeout(processingTimeout);
//         processingTimeout = null;
//       }

//       processingTimeout = setTimeout(() => {
//         manageFreeItem();
//       }, 600);
//     } catch (e) {
//       console.error('[freebie] Error in cartUpdate handler:', e);
//     }
//   });

//   setTimeout(manageFreeItem, 400);
// });


/*============================================================================
  HotSpots
==============================================================================*/

class HotSpots extends HTMLElement {
  constructor() {
    super();
    this.el = this;
    this.buttons = this.querySelectorAll("[data-button]");
    this.hotspotBlocks = this.querySelectorAll("[data-hotspot-block]");
    this.blockContainer = this.querySelector("[data-block-container]");

    this._bindEvents();
  }

  _removeActiveColorImage(swatch) {
    const id = swatch.dataset.variantId;
    this.querySelector(`.grid-product__color-image--${id}`).classList.remove(
      "is-active"
    );
  }

  /* Setup event listeners */
  _bindEvents() {
    this.buttons.forEach((button) => {
      const id = button.dataset.button;

      button.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        this._showContent(id);
      });
    });

    // Display active hotspot block on theme editor select
    document.addEventListener("shopify:block:select", (e) => {
      const blockId = e.detail.blockId;
      this._showContent(`${blockId}`);
    });
  }

  /* Toggle sidebar content */
  _showContent(id) {
    this.hotspotBlocks.forEach((block) => {
      if (block.dataset.hotspotBlock === id) {
        block.classList.add("is-active");
      } else {
        block.classList.remove("is-active");
      }
    });
  }
}

customElements.define("hot-spots", HotSpots);